/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) History Icon component.
 */
export const SentinelHistoryIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M3.4707 10.0915C3.98137 7.96352 5.22993 6.08556 6.99451 4.79128C8.75908 3.49701 10.9254 2.87025 13.1084 3.02239C15.2915 3.17454 17.3499 4.09571 18.9179 5.62225C20.4859 7.14878 21.4619 9.18178 21.6724 11.36C21.883 13.5382 21.3145 15.7205 20.0679 17.5191C18.8214 19.3177 16.9775 20.6161 14.864 21.1836C12.7505 21.7511 10.5043 21.5508 8.52448 20.6185C6.54466 19.6862 4.95952 18.0822 4.05072 16.0915' stroke={iconColor} strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M12.0605 9V13.64L15.2705 15.99' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M6.5 10.49L3.14 10.85L2 8' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};
